import { render, staticRenderFns } from "./Crisis_Committee_early.vue?vue&type=template&id=244649da"
import script from "./Crisis_Committee_early.vue?vue&type=script&lang=js"
export * from "./Crisis_Committee_early.vue?vue&type=script&lang=js"
import style0 from "./Crisis_Committee_early.vue?vue&type=style&index=0&id=244649da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports